import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState({ isAuthenticated: false, UserName: "", FullName: "" });
    const [isLoading, setIsLoading] = useState(true);
    const [customerList, setCustomerList] = useState([]);
    const [toasts, setToasts] = useState([]);

    const showToast = (toastData) => {
        setToasts((prev) => [...prev, { id: Date.now(), ...toastData }]);
    };

    const removeToast = (id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    };

    useEffect(() => {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const storedCustomers = JSON.parse(localStorage.getItem("customerList") || "[]");
        if (authUser) {
            setUser({
                isAuthenticated: !!authUser.isAuthenticated,
                UserName: authUser.UserName || authUser.USERNAME || "ADMIN",
                FullName: authUser.FullName || authUser.FULLNAME || authUser.UserName || "",
                SelectedCustomer_ID: authUser.SelectedCustomer_ID,
                SelectedCustomer_Name: authUser.SelectedCustomer_Name,
                SelectedCustomer_Address: authUser.SelectedCustomer_Address,
                SelectedCustomer_City: authUser.SelectedCustomer_City,
                SelectedCustomer_CountryName: authUser.SelectedCustomer_CountryName,
                SelectedCustomer_StateName: authUser.SelectedCustomer_StateName,
                SelectedCustomer_ZipCode: authUser.SelectedCustomer_ZipCode,
                SelectedCustomer_Phone: authUser.SelectedCustomer_Phone,
                SelectedCustomer_Email: authUser.SelectedCustomer_Email,
                Token: authUser.Token
            });
            setCustomerList(storedCustomers);
        }
        setIsLoading(false);
    }, []);

    useEffect(() => {
        if (customerList.length > 0 && user.isAuthenticated && !user.SelectedCustomer_ID) {
            const defaultCustomer = customerList.length > 1 ? customerList[1] : customerList[0];
            const updatedUser = {
                ...user,
                SelectedCustomer_ID: defaultCustomer.Customer_ID,
                SelectedCustomer_Name: defaultCustomer.FirstName,
                SelectedCustomer_Address: defaultCustomer.Address,
                SelectedCustomer_City: defaultCustomer.City,
                SelectedCustomer_CountryName: defaultCustomer.CountryName,
                SelectedCustomer_StateName: defaultCustomer.StateName,
                SelectedCustomer_ZipCode: defaultCustomer.ZipCode,
                SelectedCustomer_Phone: defaultCustomer.MobileNo,
                SelectedCustomer_Email: defaultCustomer.Email
            };
            setUser(updatedUser);
            const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
            localStorage.setItem(
                "authUser",
                JSON.stringify({
                    ...authUser,
                    ...updatedUser
                })
            );
        }
    }, [customerList, user.isAuthenticated]);

    const switchCustomer = (customer) => {
        const updatedUser = {
            ...user,
            SelectedCustomer_ID: customer.Customer_ID,
            SelectedCustomer_Name: customer.FirstName,
            SelectedCustomer_Address: customer.Address,
            SelectedCustomer_City: customer.City,
            SelectedCustomer_CountryName: customer.CountryName,
            SelectedCustomer_StateName: customer.StateName,
            SelectedCustomer_ZipCode: customer.ZipCode,
            SelectedCustomer_Phone: customer.MobileNo,
            SelectedCustomer_Email: customer.Email
        };

        setUser(updatedUser);
        const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
        localStorage.setItem("authUser", JSON.stringify({
            ...authUser,
            ...updatedUser
        }));
    };

    return (
        <AuthContext.Provider value={{ user, setUser, customerList, setCustomerList, switchCustomer, isLoading, toasts, showToast, removeToast }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
export default AuthContext;